import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "customMenu": "Покупка/Корпоративным клиентам/Корпоративные продажи",
  "customPath": "purchase/fleet/overview",
  "description": "Программа корпоративного автотранспорта ŠKODA Fleet. Преимущества ŠKODA для бизнеса. Лизинг, гарантия и сервис. Стоимость владения автомобилями ŠKODA. Подробнее на официальном сайте ŠKODA в России.",
  "huggerTemplate": "default",
  "keywords": "ŠKODA Fleet",
  "name": "fleet-overview",
  "title": "ŠKODA Fleet – корпоративные продажи автомобилей Шкода - официальный сайт ŠKODA в России"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SimpleMainStage = makeShortcode("SimpleMainStage");
const SimpleMainStageHeading = makeShortcode("SimpleMainStageHeading");
const Heading = makeShortcode("Heading");
const DefaultPaddedSection = makeShortcode("DefaultPaddedSection");
const DefaultSectionHeading = makeShortcode("DefaultSectionHeading");
const FeaturesSliderQueried = makeShortcode("FeaturesSliderQueried");
const SimpleTeaser = makeShortcode("SimpleTeaser");
const SimpleTeaserTitle = makeShortcode("SimpleTeaserTitle");
const SimpleTeaserParagraph = makeShortcode("SimpleTeaserParagraph");
const DefSectionBtnContainer = makeShortcode("DefSectionBtnContainer");
const Button = makeShortcode("Button");
const PaddedTilesContainer = makeShortcode("PaddedTilesContainer");
const PaddedTilesTile = makeShortcode("PaddedTilesTile");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <SimpleMainStage verticalAlign="bottom" horizontalAlign="left" src="/m/skoda_fleet_overview_range.jpg" mobileSrc="/m/skoda_fleet_overview_range-mob.jpg" mdxType="SimpleMainStage">
  <SimpleMainStageHeading mdxType="SimpleMainStageHeading">ŠKODA ДЛЯ ВАШЕГО БИЗНЕСА</SimpleMainStageHeading>
  <Heading size="h5" type="white" mdxType="Heading">
    Программа корпоративного автотранспорта ŠKODA Fleet
  </Heading>
    </SimpleMainStage>
    <DefaultPaddedSection bgColor="#FAFAFA" noPb mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">ПРЕИМУЩЕСТВА ŠKODA ДЛЯ БИЗНЕСА</DefaultSectionHeading>
  <FeaturesSliderQueried tags="fleet overview advantages" mdxType="FeaturesSliderQueried" />
    </DefaultPaddedSection>
    <SimpleTeaser src="/m/fleet_service_text.jpg" bgColor="#FFF" reversed noPb mdxType="SimpleTeaser">
  <SimpleTeaserTitle mdxType="SimpleTeaserTitle">ŠKODA ГАРАНТИЯ И СЕРВИС</SimpleTeaserTitle>
  <SimpleTeaserParagraph mdxType="SimpleTeaserParagraph">
    Наши клиенты получают техническое обслуживание на уровне мировых стандартов.
    С автомобилями ŠKODA Вы будете приятно удивлены снижением расходов на
    эксплуатацию и высоким уровнем качества обслуживания: линейка двигателей
    ŠKODA включает в себя как технологичные атмосферные, так и новейшие
    турбированные двигатели — достаточно мощные, но экономичные.
  </SimpleTeaserParagraph>
  <DefSectionBtnContainer mdxType="DefSectionBtnContainer">
    <Button href="/purchase/financial/leasing" mdxType="Button">ПОДРОБНЕЕ</Button>
  </DefSectionBtnContainer>
    </SimpleTeaser>
    <DefaultPaddedSection bgColor="#FAFAFA" mdxType="DefaultPaddedSection">
  <DefaultSectionHeading mdxType="DefaultSectionHeading">
    ОСТАЛИСЬ ВОПРОСЫ?
  </DefaultSectionHeading>
  <PaddedTilesContainer mdxType="PaddedTilesContainer">
    <PaddedTilesTile imgSrc="/m/question_1.png" title="ПОДРОБНЕЕ О КОРПОРАТИВНОЙ ПРОГРАММЕ" href='/m/skoda_fleet.pdf' linkText="СКАЧАТЬ БРОШЮРУ" mdxType="PaddedTilesTile" />
    <PaddedTilesTile imgSrc="/m/question_2.png" title="КОНСУЛЬТАЦИИ ПО ПРИОБРЕТЕНИЮ ŠKODA" href='/purchase/fleet/contacts' linkText="СВЯЗАТЬСЯ СО СПЕЦИАЛИСТОМ" mdxType="PaddedTilesTile" />
  </PaddedTilesContainer>
    </DefaultPaddedSection>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      